<template>

  
        <DBox
            :id="'cmp-catalog-releases-sidewindow-related_file'"
            :addButton="false"
            :addLink="true"
            :addLinkLabel="`${$t('add_new')} ${$t('related_file')}`"
            @add_click="onAddGenres"
        >
            <NTable
                class="dbox1"
                id="catalog-releases-sidewindow-related_file"
                :config="tableConfig"
                :headers="Headers"
                :items="list"
                height="170px"
            
            >
            <template v-slot:item="{ item, tdcon }">
                <tr
                   
                >
                    <td v-bind="tdcon('related_files')">
                        <span>{{item['file_description']}}</span>
                    </td>
          
                    <td v-bind="tdcon('description')">
                     
                   
                    </td>
                    <td v-bind="tdcon('option')">
                        <div class="dt-icon-container">
                          <img
                            @click.stop="(e) => deleteFile(item)"
                            src="static/icons/delete.svg"
                            class="dt-icon v5 s2"
                          />
                        </div>
                    </td>
                
                    
                </tr>
            </template>
            </NTable>
      
        </DBox>
  
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from '../../../../plugins/datatable';
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {

    selectedReleaseDetails: {
        type: Object,
    },
  },
  components: {
        NTable,
        DBox
   
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      releaseArtist:'',
      releaseTitle:'',
      releaseDate:'',
      releaseCode:'',
      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 28,
      }),
  
    };
  },
  computed:{
        Headers: function () {
            return [
                createTableHeader("related_files", {  }),
                createTableHeader("description", { }),
                createTableHeader("option",{ text:false ,mw:30})
             
                
              
            ];
        },

        list:function(){
            return this.selectedReleaseDetails.related_files||[]
        },
 
      
    },
  

 
  methods:{
    onTextFieldValueChange:function () {
      
    },
    onDropdownChange:function(item ,e){
      console.log("ITEM GENRE ENK",e)
      const payload={ 
                      name:'genre_relation_rank',
                      value:e.value,
                      item:item
                    }

      this.$emit("change",payload)
     
    },
    onDateChange:function(){
      
    },
    deleteFile:function(item){
       const payload={ file_id:item.file_id , file_relation_id:item.file_relation_id } 
       this.$emit("delete",payload)
       console.log("Genres",item)
    },
    onAddGenres:function(){
             this.$router.push({
        ...this.$route,
        query: {
          modal: "add_genre",
          external_id:this.selectedReleaseDetails.release.release_id
        },
      });
    }

  }

}
</script>
<style lang="scss">
.cmp-catalog-releases-sidewindow-related_file{
  
  .dt-ntable {
    --ntable-height: 170px;
  }

}
</style>
